module.exports = __webpack_public_path__ + "img/consult_info2.210f0508.png";